import { client } from "./_base";

export const orchards = client("producerorchard", (item) => ({
  ...item,
}));
